//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import TranslatorService from '@/services/translator'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

//
import fields from './fields'

//
export default {
    name: 'purchase-order-update',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),
        ...mapState('SnackbarModalModule', ['responseConfirm']),

        /**
         * @description
         * Params to form fields
         *
         * @return     {Object}  form field params
         */
        formParams() {
            return {
                g_branch_office_id: this.user.hr_employee.g_branch_office_id,
                is_service: this.formData.is_service,
                pch_provider_id: this.formData.pch_provider_id,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                editable: this.formData.can_rectify,
                fields: fields(this.formParams),
                loading: this.formBusy,
                switchEdit: this.formData.can_edit,
            }
        },
    },
    data() {
        return {
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            resetSnackbarState: 'resetSnackbarState',
            setErrorSnackbar: 'setErrorSnackbar',
            setInfoSnackbar: 'setInfoSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),
        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(PurchaseOrderModel, error.response.data)
            )
        },
        /**
         *
         */
        fetch() {
            PurchaseOrderModel
                .modeler()
                .find(this.$route.params.id)
                .finally(this.toggleBusy)
                .then(this.setFormData)
        },
        /**
         *
         */
        reset() {
            this.toggleBusy().then(this.fetch)
        },
        /**
         *
         */
        setFormData(model) {
            this.formData = model.reset()
        },
        /**
         *
         */
        submitCloseRectified() {
            this
                .toggleWait(true)
                .then(this.toCloseRectified)
                .then(this.toggleWait)
        },
        /**
         *
         */
        submitRectify() {
            this
                .toggleWait(true)
                .then(this.toRectify)
                .then(this.toggleWait)
        },
        /**
         *
         */
        showRectifySuccess() {
            this.setSuccessSnackbar('Precios de orden de compra rectificados exitosamente.')
        },
        /**
         *
         */
        showCloseRectifiedSuccess() {
            this.setSuccessSnackbar('Orden de compra rectificada y cerrada exitosamente.')
        },
        /**
         *
         */
        async toggleBusy() {
            this.formBusy = !this.formBusy
        },
        /**
         *
         */
        async toggleWait(value = false) {
            return this.$refs.form.setWait(value)
        },
        /**
         *
         */
        toCloseRectified(model) {
            return model
                .closeRectified()
                .attach()
                .then(this.showRectifySuccess)
                .then(this.toRedirect)
                .catch(this.error)
        },
        /**
         *
         */
        toRectify(model) {
            return model
                .rectify()
                .attach(model.toRectify())
                .then(this.showRectifySuccess)
                .then(this.toRedirect)
                .catch(this.error)
        },
        /**
         *
         */
        toRedirect() {
            return this.$router.push({
                name: this.$route.query.from || 'purchase-order-emitted',
            })
        },
    },
    beforeMount() {
        this.setTitle('Rectificar precios de orden de compra')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
